import { Injectable } from '@angular/core';
import { UserStore } from './state/user.store';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { User } from '../../../app/core/resources/user';

@Injectable({ providedIn: 'root' })
export class UserFacade {
    public readonly user: Observable<User | null> = this.store.user;
    public readonly loading: Observable<boolean> = this.store.loading;
    public readonly isAuthenticated: Observable<boolean> = this.store.isAuthenticated;

    private readonly load$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    public constructor(private store: UserStore) {}

    public loadUser(userId: string): void {
        this.store.setUserId(userId);
        this.store.loadUser(this.load$);
    }

    public refresh(): void {
        this.load$.next(null);
    }

    public get currentUserSnapshot(): User {
        let value: User = new User();
        this.currentUser.subscribe((u) => (value = u)).unsubscribe();

        return value;
    }

    public get currentUser(): Observable<User> {
        return this.user.pipe(
            filter(
                (user: User | null): user is User =>
                    user !== null && user.attributes && Object.keys(user.attributes).length > 0,
            ),
        );
    }
}
